<template>
  <div class="game_box">
    <div class="game_title">{{ $t("gameinfo.basic.gamebasicinfo") }}</div>
    <div class="xian"></div>
    <div class="game">
      <div class="BASIC">
        <div class="TGA_INPUT_BOX">
          <div class="TGA_TEXT">
            <span class="must">*</span>
            {{ $t("gameinfo.basic.gameType") }}
          </div>
          <div class="radio_btn">
            <div class="CU radio_chunk" @click="selectGameType(0)">
              <img
                class="radio_img"
                v-if="gameType == 0"
                src="@/img/radio.png"
                alt=""
              />
              <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
              <span class="radio_text">
                {{ $t("gameinfo.basic.aloneGame") }}</span
              >
            </div>
            <div class="CU radio_chunk" @click="selectGameType(1)">
              <img
                class="radio_img"
                v-if="gameType == 1"
                src="@/img/radio.png"
                alt=""
              />
              <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
              <span class="radio_text">
                {{ $t("gameinfo.basic.battleGame") }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="BASIC" v-if="gameType == 1">
        <div class="TGA_INPUT_BOX">
          <div class="TGA_TEXT">
            <span class="must">*</span>
            {{ $t("gameinfo.basic.battleSum") }}
          </div>
          <div class="radio_btn">
            <div class="CU radio_chunk" @click="selectCheckbox('1v1')">
              <img
                class="radio_img"
                v-if="pvp === '1v1'"
                src="@/img/radio.png"
                alt=""
              />
              <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
              <span class="radio_text">1v1</span>
            </div>
            <div class="CU radio_chunk" @click="selectCheckbox('3v3')">
              <img
                class="radio_img"
                v-if="pvp === '3v3'"
                src="@/img/radio.png"
                alt=""
              />
              <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
              <span class="radio_text">3v3</span>
            </div>
            <div class="CU radio_chunk" @click="selectCheckbox('5v5')">
              <img
                class="radio_img"
                v-if="pvp === '5v5'"
                src="@/img/radio.png"
                alt=""
              />
              <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
              <span class="radio_text">5v5</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 单选框 -->
      <!-- <div class="BASIC">
        <div class="TGA_INPUT_BOX">
          <div class="TGA_TEXT">
            <span class="must">*</span>
            {{ $t("gameinfo.basic.radio") }}
          </div>
          <div class="radio_btn">
            <div class="CU radio_chunk" @click="SelectRadio(0)">
              <img
                class="radio_img"
                v-if="radio == 0"
                src="@/img/radio.png"
                alt=""
              />
              <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
              <span class="radio_text">{{ $t("gameinfo.basic.across") }}</span>
            </div>
            <div class="CU radio_chunk" @click="SelectRadio(1)">
              <img
                class="radio_img"
                v-if="radio == 1"
                src="@/img/radio.png"
                alt=""
              />
              <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
              <span class="radio_text">{{
                $t("gameinfo.basic.vertical")
              }}</span>
            </div>
          </div>
        </div>
      </div> -->
      <div class="BASIC">
        <div class="TGA_INPUT_BOX">
          <div class="TGA_TEXT">
            <span class="must">*</span>
            {{ $t("foundgame.mobile") }}
          </div>
          <div class="radio_btn">
            <div class="CU radio_chunk" @click="SelectMobile(false)">
              <img
                class="radio_img"
                v-if="mobile == false"
                src="@/img/radio.png"
                alt=""
              />
              <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
              <span class="radio_text">{{ $t("foundgame.no") }}</span>
            </div>
            <div class="CU radio_chunk" @click="SelectMobile(true)">
              <img
                class="radio_img"
                v-if="mobile == true"
                src="@/img/radio.png"
                alt=""
              />
              <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
              <span class="radio_text">{{ $t("foundgame.yes") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="BASIC">
        <div class="TGA_INPUT_BOX">
          <div class="TGA_TEXT">
            <span class="must">*</span>
            {{ $t("foundgame.horizontalOnly") }}
          </div>
          <div class="radio_btn">
            <div class="CU radio_chunk" @click="SelectHorizontalOnly(false)">
              <img
                class="radio_img"
                v-if="horizontalOnly == false"
                src="@/img/radio.png"
                alt=""
              />
              <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
              <span class="radio_text">{{ $t("foundgame.no") }}</span>
            </div>
            <div class="CU radio_chunk" @click="SelectHorizontalOnly(true)">
              <img
                class="radio_img"
                v-if="horizontalOnly == true"
                src="@/img/radio.png"
                alt=""
              />
              <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
              <span class="radio_text">{{ $t("foundgame.yes") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="BASIC MG_B10">
        <div
          class="TGA_INPUT_BOX"
          :class="selectData.length <= 0 ? 'TGAdd' : ''"
        >
          <div class="TGA_TEXT">
            {{ $t("foundgame.tag.title") }}
          </div>
          <div style="width: 367px; display: flex">
            <tag-dialog
              :default-value="{
                tagId: this.tagId,
                tagCode: this.tagCode,
                onlineVersion: this.onlineVersion,
              }"
              :tagList="this.tagList"
              @close="handleDialogClose"
            ></tag-dialog>
          </div>
          <div class="init_box">
            <div class="init_text"></div>
            <div class="init_active" v-if="selectData.length <= 0">
              <img src="@/img/mistake.png" alt="" />
              <span>{{ $t("foundgame.langkong") }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="BASIC">
        <div class="TGA_INPUT_BOX">
          <div class="tag-tip-text">
            {{ $t("foundgame.tag.tip") }}
          </div>
        </div>
      </div>

      <div class="select_i8 BASIC">
        <div
          class="TGA_INPUT_BOX"
          :class="selectData.length <= 0 ? 'TGAdd' : ''"
        >
          <div class="TGA_TEXT">
            <span class="must">*</span>
            {{ $t("gameinfo.basic.lang") }}
          </div>
          <a-select
            style="height: 40px; width: 367px"
            size="large"
            mode="tags"
            :value="selectData"
            placeholder=""
            @change="handleChange"
          >
            <a-select-option
              v-for="(item, index) in adsss"
              :value="item.id.toString()"
              :key="item.id.toString()"
              :disabled="item.disabled"
              >{{ item.ct }}</a-select-option
            >
          </a-select>
          <div class="init_box">
            <!-- style="position: absolute;right: -10px;top: 0;height: 40px;" -->
            <div class="init_text"></div>
            <div class="init_active" v-if="selectData.length <= 0">
              <img src="@/img/mistake.png" alt="" />
              <span>{{ $t("gameinfo.basic.langkong") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="BASIC MG_B10" v-for="(item, index) in data">
        <div class="TGA_INPUT_BOX">
          <div class="TGA_TEXT" v-if="index == 0">
            <span class="must">*</span>
            {{ $t("gameinfo.basic.gamename") }}
          </div>
          <input
            type="text"
            class="TGA_INPUT TGA_PD"
            @blur.prevent="changeCount(item.input, index)"
            v-model="item.input"
            :placeholder="item.ct"
          />
          <div class="init_box" style="width: 300px">
            <div class="init_text">({{ item.ct }})</div>
          </div>
        </div>
      </div>

      <div style="margin-top: 25px">
        <div class="BASIC MG_B10" v-for="(item, index) in data">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" v-if="index == 0">
              <span class="must">*</span>
              {{ $t("gameinfo.basic.gameinfo") }}
            </div>
            <textarea
              class="TGA_PD"
              style="width: 367px; height: 120px; padding-top: 8px"
              @blur.prevent="changeCount(item.textarea, index)"
              name=""
              :placeholder="item.ct"
              id=""
              v-model="item.textarea"
            ></textarea>
            <div class="init_box">
              <div class="init_text">({{ item.ct }})</div>
            </div>
          </div>
        </div>
      </div>

      <div class="btn CU" :class="BTN ? '' : 'btn_active'" @click="establish">
        {{ $t("gameinfo.basic.send") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import TagDialog from "../TagDialog.vue";
export default {
  components: {
    TagDialog,
  },
  data() {
    return {
      appId: this.$route.query.appId,
      gameId: this.$route.query.gameId,
      BTN: false,
      mobile: false,
      horizontalOnly: false,
      pvp: "",
      selectData: ["EN"],
      radio: "0",
      gameType: 0,
      battles: [],
      data: [
        {
          ct: this.$t("gameinfo.basic.english"),
          id: "EN",
          input: "",
          textarea: "",
          active: false,
        },
      ],
      adsss: [
        {
          ct: this.$t("gameinfo.basic.chinese"),
          id: "ZH",
          input: "",
          textarea: "",
          active: false,
          disabled: false,
        },
        {
          ct: this.$t("gameinfo.basic.english"),
          id: "EN",
          input: "",
          textarea: "",
          active: false,
          disabled: true,
        },
        {
          ct: this.$t("gameinfo.basic.Turkey"),
          id: "TR",
          input: "",
          textarea: "",
          active: false,
          disabled: false,
        },
      ],
      tagList: [],
      tagId: [],
      tagCode: [],
    };
  },
  computed: {
    ...mapState("game", ["GameAppInfo"]),
  },

  created() {
    this.getList();
    if (this.GameAppInfo == "") {
      this.load();
    } else {
      this.vuexLoad();
    }
  },
  mounted() {},
  methods: {
    ...mapActions("user", ["tipMessage"]),
    ...mapActions("game", [
      "getGameDeveloperInfo",
      "updateGameDeveloper",
      "getTagList",
    ]),
    // 选择游戏类型
    async getList() {
      var res = await this.getTagList({
        $axios: this.$axios,
      });
      console.log("res", res);
      if (res.code == 200) {
        this.tagList = res.data;
      }
    },
    selectGameType(index) {
      if (this.gameType == index) {
        return;
      }
      this.battles = [];
      this.gameType = index;
    },

    // 多选按钮
    selectCheckbox(text) {
      console.log("text", text);
      this.pvp = text;
    },

    vuexLoad() {
      var data = this.GameAppInfo.gameDeveloperVo;
      this.onlineVersion = this.GameAppInfo.onlineVersion;
      this.selectData = data.gameLang;
      var ipt = [];
      for (var i = 0; i < data.name.length; i++) {
        for (var j = 0; j < this.adsss.length; j++) {
          if (data.name[i].lang == this.adsss[j].id) {
            ipt.push(this.adsss[j]);
            ipt[i].input = data.name[i].values;
            ipt[i].textarea = data.description[i].values;
          }
        }
      }
      this.radio = data.orientation;
      this.data = ipt;
      this.pvp = data.battlePlayersNum;
      this.tagId = data.tagId;
      this.tagCode = data.tagCode;
      this.gameType = data.type;
      this.mobile = data.mobileCompatible;
      this.horizontalOnly = data.horizontalOnly;
    },

    async load() {
      var res = await this.getGameDeveloperInfo({
        $axios: this.$axios,
        gameId: this.gameId,
      });

      if (res.code == 200) {
        var data = res.data.gameDeveloperVo;
        this.onlineVersion = res.data.onlineVersion;

        this.selectData = data.gameLang;
        var ipt = [];
        for (var i = 0; i < data.name.length; i++) {
          for (var j = 0; j < this.adsss.length; j++) {
            if (data.name[i].lang == this.adsss[j].id) {
              ipt.push(this.adsss[j]);
              ipt[i].input = data.name[i].values;
              ipt[i].textarea = data.description[i].values;
            }
          }
        }
        this.radio = data.orientation;
        this.data = ipt;
        this.pvp = data.battlePlayersNum;
        this.tagId = data.tagId;
        this.tagCode = data.tagCode;
        this.gameType = data.type;
        this.mobile = data.mobileCompatible;
        this.horizontalOnly = data.horizontalOnly;
      }
    },

    // 点击按钮创建游戏
    async establish() {
      if (!this.BTN) {
        return;
      }
      if (this.gameType == 1 && this.pvp === "") {
        return;
      }

      var appName = [];
      var appInfo = [];
      for (var i = 0; i < this.data.length; i++) {
        var OB = {
          lang: this.data[i].id,
          values: this.data[i].input,
        };
        var info = {
          lang: this.data[i].id,
          values: this.data[i].textarea,
        };
        appName.push(OB);
        appInfo.push(info);
      }

      var obj = {
        orientation: this.radio,
        gameLang: JSON.stringify(this.selectData),
        name: JSON.stringify(appName),
        description: JSON.stringify(appInfo),
        tagId: JSON.stringify(this.tagId),
        tagCode: JSON.stringify(this.tagCode),
        type: this.gameType,
        battlePlayersNum: this.pvp,
        mobileCompatible: this.mobile,
        horizontalOnly: this.horizontalOnly,
      };

      var res = await this.updateGameDeveloper({
        $axios: this.$axios,
        id: this.gameId,
        ...obj,
      });

      if (res.code == 200) {
        this.$message.success(this.$t("gameinfo.basic.success"));
      } else {
        this.$message.error(this.$t("gameinfo.basic.error"));
      }
    },

    changeCount(text, i) {
      if (text == "") {
        this.data[i].active = true;
      } else {
        this.data[i].active = false;
      }
    },
    SelectRadio(index) {
      this.radio = index;
    },
    SelectMobile(boolean) {
      this.mobile = boolean;
    },
    SelectHorizontalOnly(boolean) {
      this.horizontalOnly = boolean;
    },
    handleChange(value) {
      var self = this;
      this.selectData = value;
      var data = [];
      for (var i = 0; i < value.length; i++) {
        for (var j = 0; j < this.adsss.length; j++) {
          if (value[i] == this.adsss[j].id) {
            data.push(this.adsss[j]);
          }
        }
      }

      this.data = data;
      console.log(this.data);
    },
    filterDeliverOption(input, option) {
      console.log("input, option", input, option);
      // return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },

  watch: {
    data: {
      handler: function (newValue, oldValue) {
        console.log("newValue", newValue);

        if (newValue.length <= 0) {
          this.BTN = false;
          return;
        }
        var obj = newValue.find((res) => res.input == "" || res.textarea == "");
        if (!obj) {
          this.BTN = true;
        } else {
          this.BTN = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped="scoped">
.game_box {
  width: 100%;
  height: 100%;
}
.game_title {
  padding-left: 50px;
  font-size: 18px;
  color: #282828;
}
.xian {
  width: 100%;
  height: 1px;
  margin-top: 14px;
  background-color: #f3f3f3;
}
.game {
  margin-top: 31px;
  /* padding-left: 50px; */
}

.BASIC {
  display: flex;
  margin-bottom: 25px;
  padding-left: 200px;
}

.game_Progress_box {
  width: 906px;
  position: relative;
  margin: 50px auto;
  display: flex;
  justify-content: space-between;
}
.game_Progress {
  width: 860px;
  height: 2px;
  position: absolute;
  top: 5px;
  left: 25px;
  background-color: #dddddd;
}
.game_Progress_wid {
  width: 148px;
  height: 2px;
  background-color: #4990fa;
}
.game_Progress_centent {
  position: relative;
  z-index: 10;

  display: flex;
  flex-direction: column;
  align-items: center;
}
.game_Progress_sum {
  width: 18px;
  height: 18px;
  background-color: #4990fa;
  border-radius: 50%;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  line-height: 18px;
}
.game_Progress_text {
  margin-top: 14px;
  font-size: 14px;
  color: #666666;
}
.radio_btn {
  height: 40px;
  width: 367px;
  display: flex;
  align-items: center;
}
.radio_chunk {
  display: flex;
  align-items: center;
  margin-right: 40px;
}

.radio_text {
  color: #282828;
  font-size: 14px;
  margin-left: 10px;
}

.game .TGA_TEXT {
  line-height: 40px;
}
.game .TGA_INPUT {
  width: 367px;
  height: 40px;
}
.game .TGA_INPUT_INIT {
  height: 40px;
}
.select_i8 {
  display: flex;
  padding-left: 200px;
}
.init_box {
  width: 300px;
  position: absolute;
  right: -310px;
  top: 0;
  display: flex;
  height: 40px;
  align-items: center;
}
.init_text {
  font-size: 12px;
  color: #8eb5fb;
}
.init_active {
  margin-left: 10px;
  height: 100%;
  display: flex;
  align-items: center;
}
.init_active span {
  margin-left: 7px;
  color: #f65651;
  font-size: 14px;
}
textarea {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}
textarea:focus {
  outline: none !important;
  border: 1px solid #40a9ff;
}

.check_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.nocheck {
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  border-radius: 2px;
  border: solid 1px #282828;
}
.check {
  width: 14px;
  height: 14px;
}
.checktext {
  margin-left: 9px;
}
.checktext span {
  font-size: 14px;
  color: #4990fa;
}
.btn {
  margin: 30px 0 0 200px;
  width: 367px;
  height: 50px;
  background-color: #4990fa;
  border-radius: 4px;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  font-size: 16px;
}

.btn_active {
  background-color: #dddddd;
}
/* .TGAa  .ant-select-selection{
      background-color: red;
    } */
.TGAdd .ant-select-selection.ant-select-selection--multiple {
  border: 1px solid red;
}

.MG_B10 {
  margin-bottom: 10px;
}
.tag-tip-text {
  font-size: 14px;
  color: #aaaaaa;
}
</style>



// WEBPACK FOOTER //
// src/components/games/gameinfo/basic.vue